import brandit_rails from '../../../../api/brandit_rails'
import { setAuthStatusAction, setAuthErrorsAction, setRedirectUriAction, updateAuthAction } from './auth.actions'

const unauthorizedResponse = ({ data, auth0 = false }) => {
  if (auth0)
    return {
      message:
        "We don't have an account associated with this email address. Please contact an administrator to create an account for you."
    }

  switch (data.error_code) {
    case 'black_listed':
      return { message: 'Not Authorized IP.' }
    case 'not_active':
      return { message: `Your account is not active. ${data.message ?? ''}` }
    case 'token_required':
      return {
        message: data.message ?? 'Please enter 2 factor authentication Token.',
        action: 'token_required'
      }
    default:
      if (data?.message) {
        return { message: data.message }
      }
      return { message: 'Email or password invalid.' }
  }
}

const unprocessableResponse = ({ data }) => {
  if (data.base) return { message: data.base[0] }
  return { message: 'Email or password invalid.' }
}

export const createSession = credentials => async dispatch => {
  try {
    dispatch(setAuthStatusAction('loading'))

    localStorage.setItem('initialAuth', true)

    const { data } = await brandit_rails.post('/sessions', credentials)

    if (!data) throw new Error('No JWT token received from server.')

    dispatch(
      updateAuthAction({
        tokenVerified: true,
        status: 'succeeded',
        errors: [],
        task: null,
        token: data
      })
    )

    const redirect = localStorage.getItem('redirectUrl')

    if (redirect && redirect !== '/') {
      localStorage.removeItem('redirectUrl')
      window.location.href = redirect
    }

    return data
  } catch (err) {
    if (err.response) {
      if (err.response?.status === 401) {
        dispatch(setAuthErrorsAction(unauthorizedResponse({ data: err.response.data, auth0: !!credentials.auth0 })))
        dispatch(setRedirectUriAction({ url: '/login' }))
      } else if (err.response?.status === 422)
        dispatch(setAuthErrorsAction(unprocessableResponse({ data: err.response.data })))

      dispatch(setAuthStatusAction('failed'))
      return err.response
    } else dispatch(setAuthErrorsAction({ message: err.message }))
  }
}

export const standardLogin = credentials => async dispatch => {
  dispatch(updateAuthAction({ task: 'login', errors: [] }))

  const data = await createSession(credentials)(dispatch)
  return data
}

export const forgotPassword = email => async dispatch => {
  try {
    dispatch(updateAuthAction({ status: 'loading', task: 'forgotPassword', errors: [] }))

    const { data } = await brandit_rails.post('/admins/forgot_password', { admin: { email } })

    dispatch(setAuthStatusAction('succeeded'))

    return data
  } catch (err) {
    dispatch(setAuthErrorsAction({ message: err.response.data.error }))
    dispatch(setAuthStatusAction('failed'))
  }
}

export const verifyPasswordToken = token => async dispatch => {
  try {
    dispatch(updateAuthAction({ status: 'loading', task: 'verifyPasswordToken', errors: [] }))

    await brandit_rails.post('/admins/verify_password_token', {
      admin: { token }
    })

    dispatch(setAuthStatusAction('succeeded'))
  } catch (err) {
    dispatch(setAuthErrorsAction({ action: 'verify_token', message: err.response.data.error }))
    dispatch(setAuthStatusAction('failed'))
  }
}

export const resetPassword = (token, newPassword) => async dispatch => {
  try {
    dispatch(updateAuthAction({ status: 'loading', task: 'resetPassword', errors: [] }))

    await brandit_rails.put(`/admins/reset_password/${token}`, {
      admin: {
        password: newPassword,
        password_confirmation: newPassword
      }
    })

    dispatch(setAuthStatusAction('succeeded'))
  } catch (err) {
    dispatch(setAuthErrorsAction({ message: err.response.data.error }))
    dispatch(setAuthStatusAction('failed'))
  }
}

export const ssoLogin = (ssoId, ssoToken) => async dispatch => {
  try {
    dispatch(updateAuthAction({ status: 'loading', task: 'login', errors: [] }))

    // Validate required parameters
    if (!ssoId || !ssoToken) {
      throw new Error('SSO ID and token are required.')
    }

    // Retrieve store domain asynchronously
    const getStoreDomain = () => {
      return new Promise(resolve => {
        const queryParams = new URLSearchParams(window.location.search)
        const domain = queryParams.get('store_domain') ?? '/login'
        resolve(domain)
      })
    }

    const storeDomain = await getStoreDomain()
    const logoutDestination = storeDomain
    localStorage.setItem('store_domain', logoutDestination)

    // Update authentication token and status

    dispatch(updateAuthAction({ status: 'succeeded', token: ssoToken }))
    dispatch(setAuthStatusAction('succeeded'))

    // Return a success response for consumers
    return { success: true, storeDomain }
  } catch (err) {
    // Handle errors gracefully
    dispatch(setAuthErrorsAction({ message: err.message }))
    dispatch(setAuthStatusAction('failed'))

    // Re-throw the error for consumers to handle
    throw err
  }
}
